import React, { useState } from 'react';
import { FaUndoAlt, FaUser } from 'react-icons/fa';
import ConfirmWithPhrasePopup from '../Common/ConfirmWithPhrasePopup';
import '../../css/Users/UsersManager.css';

const DeletedUsersList = ({ deletedUsers, onReactivate }) => {
  const [userToReactivate, setUserToReactivate] = useState(null);

  const formatDate = (iso) =>
    new Date(iso).toLocaleDateString('pl-PL');

  const handleConfirm = () => {
    if (userToReactivate) {
      onReactivate(userToReactivate.guid);
      setUserToReactivate(null);
    }
  };

  return (
    <div className="usersmanager-userlist">
      <div className="activeusers-header">Usunięte osoby</div>
      {deletedUsers.length === 0 ? (
        <div className="usersmanager-empty">Brak usuniętych użytkowników.</div>
      ) : (
        deletedUsers.map(user => (
          <div
            key={user.guid}
            className="usersmanager-user-card deleted"
          >
            <div className="usersmanager-user-main">
              <span className="usersmanager-user-name">
                <FaUser style={{ marginRight: 6 }} />
                {user.name}
              </span>
              <div className="usersmanager-user-actions">
                <div
                  className="usersmanager-action-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    setUserToReactivate(user);
                  }}
                >
                  <FaUndoAlt />
                </div>
              </div>
            </div>
          </div>
        ))
      )}

      {userToReactivate && (
        <ConfirmWithPhrasePopup
          text={
            <>
              Czy na pewno chcesz przywrócić osobę{" "}
              <strong>
                <FaUser /> {userToReactivate.name}
              </strong>
              ?
            </>
          }
          phrase="okoń"
          onConfirm={handleConfirm}
          onCancel={() => setUserToReactivate(null)}
        />
      )}
    </div>
  );
};

export default DeletedUsersList;
